import React, { Dispatch, SetStateAction } from 'react'
import { Modal } from 'components'

import * as S from './styles'

interface ModalOrderOverviewProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  onReturn?: () => void
  children?: React.ReactNode
}

const ModalOrderOverview: React.FC<ModalOrderOverviewProps> = ({
  open,
  setOpen,
  onConfirm,
  onReturn = () => setOpen(false),
  children
}) => {
  return (
    <Modal
      open={open}
      titleSize={22}
      modalWidth={456}
      setOpen={setOpen}
      showReturn
      returnIcon={''}
      returnText="Criar novo pedido"
      returnAction={onReturn}
      buttonText="Gerenciamento"
      buttonAction={onConfirm}
      showClose={false}
      closeAction={onReturn}
    >
      {children}
      <S.ObservationText>
        As OVs geradas serão <b>enviadas automaticamente ao SAP.</b> Materiais em aberto
        ou em análise <b>não possuem garantia de disponibilidade.</b>
      </S.ObservationText>
    </Modal>
  )
}

export default ModalOrderOverview
